import React from 'react';
import PropTypes from 'prop-types';
import FontAwesome from 'Components/UI/FontAwesome/FontAwesome';
import { openModal } from 'Helpers/ModalHelper';
import modalConsts from 'Consts/ModalNames';
import { Button, Tooltip } from '@material-ui/core';
import './index.css';
import { dataAttrs } from 'Helpers/Testing';

const ClientInfoButton = ({ householdId }) => {
  function onClick() {
    openModal(modalConsts.householdInfo, [{ householdId }]);
  }

  return (
    <div className="client-info-button">
      <Tooltip title="Client Information" arrow>
        <Button color="primary" onClick={onClick} {...dataAttrs('client-info-button')}>
          <FontAwesome icon="gear" fontSize="22px" />
        </Button>
      </Tooltip>
    </div>
  );
};

ClientInfoButton.propTypes = {
  householdId: PropTypes.string.isRequired,
};

export default ClientInfoButton;
